import React, { FC } from 'react';
import { fixed } from 'helicon/build';
import { ValueInputProps } from './ValueInput';
import { AudioBufferInput } from './AudioBufferInput';

export const AudioBufferFixedValueInput: FC<ValueInputProps<string>> = ({
  id,
  tabIndex,
  seededValue,
  onChange,
  disabled,
}) => {
  return (
    <AudioBufferInput
      id={id}
      tabIndex={tabIndex}
      disabled={disabled}
      value={seededValue}
      onChange={value => onChange(fixed(value))}
    />
  );
};
